import api from '@/api';
import type { components } from '@/api/qraft/schema';

type ProfileType = components['schemas']['ProfileType'];

const STUDENT_TYPES: ProfileType[] = [
  'WEB_STUDENT',
  'LITEAPP_STUDENT',
  'EMAIL_STUDENT',
  'POSTAL_STUDENT',
];

// TODO: Implement unique UI for more user types, rather than defining as only student or study helper
const STUDY_HELPER_TYPES: ProfileType[] = [
  'STUDY_HELPER',
  'FOLLOWUP_COORDINATOR',
  'FOLLOWUP_PARTNER',
  'ADMIN',
];

export function useCurrentUser() {
  const { data: me, isPending, ...rest } = api.getCurrentUser.useQuery();

  const isStudent = me?.profile_type
    ? STUDENT_TYPES.includes(me.profile_type)
    : false;

  const isStudyHelper = me?.profile_type
    ? STUDY_HELPER_TYPES.includes(me.profile_type)
    : false;

  const isAdmin = me?.profile_type === 'ADMIN';

  const isViewingOwnProfile = (memberId: string) =>
    me?.id?.toString() === memberId;

  return {
    me,
    isStudent,
    // Both role flags read `false` until `me` arrives, which is indistinguishable
    // from "definitely not a study helper". Anything that *branches* on the role
    // — e.g. picking which post kind to request — must gate on `isPending` first,
    // or its first render commits to the student answer and has to redo the work
    // (and cache the 404) once the real profile lands.
    isPending,
    isStudyHelper,
    isAdmin,
    isViewingOwnProfile,
    ...rest,
  };
}
